import defaultParams from './state'


export function setDefaultParams(state){
    state.params=defaultParams;
}


// WEBPACK FOOTER //
// ./src/modules/inventory-users/mutations.js